import React from 'react';
import { styled } from '@mui/material';
import clsx from 'clsx';
import { FormItem } from '../../FormItem';
import { Input } from '../../Input';
import TextArea from '../../Input/lib/TextArea';
import { useTranslation } from '../../hooks/useTranslation';
import { useMixedValue } from '../../hooks/useMixedValue';
import { getStyle, textFieldClasses } from './style';
const TextFieldBase = (props, ref) => {
    const { InputProps, TextAreaProps, type = 'input', id, showCount, allowExceedMaxLength, errors = [], placeholder, value, className, defaultValue, showMaxExceededIndicator = false, showCountPosition, onChange, maxLength, maxExceededError, ...formItemProps } = props;
    const { t } = useTranslation('Input');
    const [innerValue, onUpdate] = useMixedValue(value, defaultValue, (value, e) => {
        onChange?.(e, value);
    });
    const isValidAllowExceedMaxLength = allowExceedMaxLength === true &&
        typeof maxLength === 'number' &&
        maxLength > 0;
    const countMessage = React.useMemo(() => {
        if (!showCount)
            return '';
        if ((maxLength ?? -1) <= -1)
            return String(innerValue ?? '').length;
        return `${String(innerValue ?? '').length} / ${maxLength}`;
    }, [showCount, maxLength, innerValue]);
    const isExceedMaxLen = isValidAllowExceedMaxLength && String(innerValue).length > maxLength;
    const _formItemProps = type === 'input'
        ? {
            ...(formItemProps || {}),
            id,
            countMessage: showCount && showMaxExceededIndicator && !isExceedMaxLen
                ? countMessage
                : undefined,
            maxExceededIndicator: showCount && showMaxExceededIndicator && isExceedMaxLen
                ? countMessage
                : undefined,
            showCountPosition,
        }
        : {
            ...(formItemProps || {}),
            id,
            countMessage: showCount && !isExceedMaxLen ? countMessage : undefined,
            maxExceededIndicator: showCount && showMaxExceededIndicator && isExceedMaxLen
                ? countMessage
                : undefined,
            showCountPosition,
        };
    const _errors = isExceedMaxLen
        ? [maxExceededError ?? t('maxLengthMessage', { maxLength })]
        : errors;
    const handleChange = (e) => {
        onUpdate(e.target.value, e);
    };
    const inputShowCountProp = !showMaxExceededIndicator && showCount
        ? {
            formatter: () => countMessage,
        }
        : false;
    return (React.createElement(FormItem, { ..._formItemProps, errors: _errors, className: clsx(className, textFieldClasses.root) }, type === 'input' ? (React.createElement(Input, { ...InputProps, ref: ref, showCount: inputShowCountProp, value: innerValue, placeholder: placeholder, onChange: handleChange, maxLength: isValidAllowExceedMaxLength ? undefined : maxLength })) : (React.createElement(TextArea, { ...TextAreaProps, ref: ref, value: innerValue, placeholder: placeholder, onChange: handleChange, maxLength: isValidAllowExceedMaxLength ? undefined : maxLength }))));
};
const StyledTextField = styled(React.forwardRef(TextFieldBase))(() => getStyle());
export const TextField = React.forwardRef((props, ref) => (React.createElement(StyledTextField, { ...props, ref: ref })));
